import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { updatePageMeta } from '../utils/seo';
import { TEXT_STYLES, BUTTON_STYLES } from '../constants/styles';

function NotFound() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    updatePageMeta(
      'Page Not Found - Stephanie Zhang',
      'The page you\'re looking for doesn\'t exist or has been moved.'
    );
  }, []);

  return (
    <div className="w-full overflow-x-hidden bg-white min-h-screen pt-32 pb-16">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
          <h1 className="text-8xl md:text-9xl font-playfair font-normal text-[#0D0D0D] mb-4">
            404
          </h1>
          <h2 className="text-2xl md:text-3xl font-playfair font-normal text-[#0D0D0D] mb-6">
            Page not found
          </h2>
          <p className={`${TEXT_STYLES.body} text-lg max-w-md mb-10`}>
            The page you're looking for doesn't exist or has been moved.
          </p>
          <Link
            to="/"
            className={`${BUTTON_STYLES.primary}`}
            onClick={() => window.scrollTo(0, 0)}
          >
            Back to home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
